export default "__VITE_ASSET__CFoDSFBw__"